// DS2.5.3, DS2.5.3M
import _extends from "@swc/helpers/src/_extends.mjs";
import React, { useContext, useMemo } from 'react';
import classnames from 'classnames';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import PlainButtonOrLink from '../../Buttons/PlainButtonOrLink';
import Comment from '../../Icons/24x24/Comment';
import CommentOutline from '../../Icons/24x24/CommentOutline';
import FavStar from '../../Icons/24x24/FavStar';
import FavStarFill from '../../Icons/24x24/FavStarFill';
import { IconSize } from '../../Icons/IconWrap';
import shortenNumber from '../../../utils/shortenNumber';
import { setRef } from '../../../utils/refHelpers';
import s from './ThumbIconButton.scss';
const ThumbIconButton = /*#__PURE__*/ React.forwardRef(({ type , isEngaged =false , statValue =0 , showStatValue =true , className , href , biData , onClick  }, ref)=>{
    const isMobile = useContext(MobileContext);
    const icon = useMemo(()=>{
        const iconProps = {
            size: isMobile ? IconSize.MEDIUM : IconSize.SMALLER,
            disableDefaultColors: true,
            className: s['icon']
        };
        switch(type){
            case 'comment':
                return isEngaged ? /*#__PURE__*/ React.createElement(Comment, _extends({}, iconProps)) : /*#__PURE__*/ React.createElement(CommentOutline, _extends({}, iconProps));
            case 'fave':
                return isEngaged ? /*#__PURE__*/ React.createElement(FavStarFill, _extends({}, iconProps)) : /*#__PURE__*/ React.createElement(FavStar, _extends({}, iconProps));
            default:
                return null;
        }
    }, [
        isEngaged,
        isMobile,
        type
    ]);
    return /*#__PURE__*/ React.createElement(PlainButtonOrLink, {
        innerRef: (node)=>setRef(ref, node),
        href: href,
        onClick: onClick,
        className: classnames(s['root'], className),
        biData: biData
    }, icon, showStatValue && /*#__PURE__*/ React.createElement("span", {
        className: s['value']
    }, shortenNumber(statValue)));
});
ThumbIconButton.displayName = 'ThumbIconButton';
export default ThumbIconButton;
